import { trackAnalyticsSafely } from "./AnalyticsTracker";
import {
    TwoFactorAuthenticationDeviceDeactivationPayload,
    TwoFactorAuthenticationDevicesSummaryPayload,
    TwoFactorAuthenticationInstallInvitationPayload,
    TwoFactorAuthenticationModeChangePayload,
    TwoFactorAuthenticationPolicySummaryPayload,
    TwoFactorAuthenticationSubjectTogglePayload,
} from "./TwoFactorAuthenticationEvents";

export class TwoFactorAuthenticationAnalyticsHelper {
    static trackConfigurationShown(payload: TwoFactorAuthenticationPolicySummaryPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.ConfigurationShown",
            payload,
        });
    }

    static trackConfigurationRefreshed(payload: TwoFactorAuthenticationPolicySummaryPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.ConfigurationRefreshed",
            payload,
        });
    }

    static trackConfigurationLoadFailed() {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.ConfigurationLoadFailed",
        });
    }

    static trackModeChangeSubmitted(payload: TwoFactorAuthenticationModeChangePayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.ModeChangeSubmitted",
            payload,
        });
    }

    static trackModeChangeSucceeded(payload: TwoFactorAuthenticationModeChangePayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.ModeChangeSucceeded",
            payload,
        });
    }

    static trackModeChangeFailed(payload: TwoFactorAuthenticationModeChangePayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.ModeChangeFailed",
            payload,
        });
    }

    static trackSubjectToggleSubmitted(payload: TwoFactorAuthenticationSubjectTogglePayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.SubjectToggleSubmitted",
            payload,
        });
    }

    static trackSubjectToggleSucceeded(payload: TwoFactorAuthenticationSubjectTogglePayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.SubjectToggleSucceeded",
            payload,
        });
    }

    static trackSubjectToggleFailed(payload: TwoFactorAuthenticationSubjectTogglePayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.SubjectToggleFailed",
            payload,
        });
    }

    static trackDevicesShown(payload: TwoFactorAuthenticationDevicesSummaryPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.DevicesShown",
            payload,
        });
    }

    static trackDevicesRefreshed(payload: TwoFactorAuthenticationDevicesSummaryPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.DevicesRefreshed",
            payload,
        });
    }

    static trackDevicesLoadFailed() {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.DevicesLoadFailed",
        });
    }

    static trackDeviceDeactivationSubmitted(payload: TwoFactorAuthenticationDeviceDeactivationPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.DeviceDeactivationSubmitted",
            payload,
        });
    }

    static trackDeviceDeactivationSucceeded(payload: TwoFactorAuthenticationDeviceDeactivationPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.DeviceDeactivationSucceeded",
            payload,
        });
    }

    static trackDeviceDeactivationFailed(payload: TwoFactorAuthenticationDeviceDeactivationPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.DeviceDeactivationFailed",
            payload,
        });
    }

    static trackInstallInvitationSubmitted(payload: TwoFactorAuthenticationInstallInvitationPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.InstallInvitationSubmitted",
            payload,
        });
    }

    static trackInstallInvitationSucceeded(payload: TwoFactorAuthenticationInstallInvitationPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.InstallInvitationSucceeded",
            payload,
        });
    }

    static trackInstallInvitationFailed(payload: TwoFactorAuthenticationInstallInvitationPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.TwoFactorAuthentication.InstallInvitationFailed",
            payload,
        });
    }
}
